export const MANAGE_CARDS = 'Manage Cards';
export const COMBINE_CARDS = 'Combine cards';
export const CHECK_BALANCE = 'Check balance';
